import React from 'react';
import { useUserConfig, useUserConfigDispatch } from '@/context/UserConfigContext';
import { GearConfigForm } from '@/components/config_forms/gear/GearConfigForm';
import { GearKitForm } from '@/components/config_forms/gear/GearKitForm';
import { DEFAULT_GEAR_CONFIG } from '@/types/GearConfig';

export const UserGearConfig: React.FC = () => {
  const { state } = useUserConfig();
  const { updateGearConfig } = useUserConfigDispatch();

  const gear = state.gearConfig ?? DEFAULT_GEAR_CONFIG;

  return (
    <div className="space-y-6">
      <GearConfigForm
        config={gear}
        onChange={(updated) => updateGearConfig(updated)}
      />
      <GearKitForm
        kits={gear.gearKits}
        availableItems={gear.gearItems}
        onChange={(kits) => updateGearConfig({ gearKits: kits })}
      />
    </div>
  );
};
